import 'angular:locale/data:ja-JP';
import 'angular:locale/data:zh-Hans';
import 'angular:locale/data:qps-Ploc';
import 'angular:locale/data:pt-BR';
import 'angular:locale/data:fr-CA';
import 'angular:locale/data:he';
import 'angular:locale/data:es';
import 'angular:locale/data:en-US';
import 'angular:locale/data:en-GB';
import 'zone.js';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
